import React, { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { fetchQualityApprovalsWithFilters, fetchQualityApprovalData } from './store/slice';
import { showToast } from 'Core/redux/toast/slice';
import QualityApprovalTopHead from './qualityapproval-top-head';
import QualityApprovalContent from './qualityapproval-content';
import QualityApprovalModals from './qualityapproval-modals';
import { actions as qualityApprovalActions } from './store/slice';
import { fetchAllProcessStatuses } from '../../core/redux/status/slice';
import { parseQualityApprovalDeepLink } from './qualityapproval-deep-link';
import { selectFilteredQualityApprovals } from './store/selectors';

const { resetFilters, setFilterVisible, setSelectedPart } = qualityApprovalActions;

const QualityApprovalView = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const openedDeepLinkKeyRef = useRef(null);
  const qualityApprovals = useSelector(selectFilteredQualityApprovals);

  useEffect(() => {
    dispatch(fetchQualityApprovalsWithFilters());
    dispatch(fetchAllProcessStatuses());
    return () => {
      dispatch(resetFilters());
      dispatch(setFilterVisible(false))
    }
  }, []);

  useEffect(() => {
    const deepLink = parseQualityApprovalDeepLink(location.search);
    if (!deepLink) {
      openedDeepLinkKeyRef.current = null;
      return undefined;
    }

    const key = `${deepLink.partId || ''}:${deepLink.requestId || ''}:${deepLink.partNumber || ''}`;
    if (openedDeepLinkKeyRef.current === key) {
      return undefined;
    }

    const list = Array.isArray(qualityApprovals) ? qualityApprovals : [];
    let partId = deepLink.partId;
    let partNumber = deepLink.partNumber;

    const match = list.find(item => {
      const itemId = Number(item.id ?? item.partId);
      const itemPartNumber = String(item.partNumber || '').trim().toLowerCase();
      if (partId && Number.isFinite(itemId) && itemId === partId) {
        return true;
      }
      if (partNumber && itemPartNumber === partNumber.toLowerCase()) {
        return true;
      }
      return false;
    });

    if (match) {
      partId = Number(match.id ?? match.partId) || partId;
      partNumber = match.partNumber || partNumber;
    }

    if (!partId) {
      if (list.length > 0 && partNumber) {
        dispatch(
          showToast({
            message: `Could not open Accept/Reject for part ${partNumber}.`,
            type: 'warning',
          }),
        );
        openedDeepLinkKeyRef.current = key;
      }
      return undefined;
    }

    dispatch(
      setSelectedPart({
        id: partId,
        partNumber,
      }),
    );
    dispatch(fetchQualityApprovalData({ id: partId, partNumber }));
    openedDeepLinkKeyRef.current = key;
    return undefined;
  }, [dispatch, location.search, qualityApprovals]);

  return (
    <div>
      <div className="page-wrapper">
        <div className="content">
          <div className="page-header transfer">
            <div className="add-item d-flex">
              <div className="page-title">
                <h4>QualityApproval</h4>
              </div>
            </div>
            <QualityApprovalTopHead />
          </div>
          <QualityApprovalContent />
          <QualityApprovalModals />
        </div>
      </div>
    </div>
  );
};

export default QualityApprovalView;
